var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},'svg',_vm.$attrs,false),[_c('use',{attrs:{"xlink:href":("/symbols.svg#" + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }